import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

/**
 * The scrolling region for a page inside the group shell.
 *
 * The shell owns the header and the tab bar; everything between them scrolls here and
 * nowhere else, so the bar can never drift and no page needs bottom padding to clear it.
 */
export function PageScroll({
  children,
  className,
  width = "wide",
}: {
  children: ReactNode;
  className?: string;
  width?: "narrow" | "medium" | "wide";
}) {
  return (
    <div className={cn("scroll-region min-h-0 flex-1 overflow-y-auto", className)}>
      <div
        className={cn(
          "mx-auto w-full pb-10",
          width === "narrow" && "max-w-xl",
          width === "medium" && "max-w-2xl",
          width === "wide" && "max-w-3xl",
        )}
      >
        {children}
      </div>
    </div>
  );
}
